/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "memberships": {
        "nested": {
          "model": {
            "nested": {
              "ProgressMetric": {
                "values": {
                  "PROGRESS_DO_NOT_USE": 0,
                  "LOYALTY_POINTS": 1
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.memberships?.nested?.model?.nested?.ProgressMetric) {
	$root.addJSON(jsonData);
}

/**
 * --
 * @desc The value used to measure progress between tiers.
 * --
 *
 * SOURCE ProgressMetric @ squareup/memberships/model/progress-metric.proto at 16:1
 */
export const ProgressMetric = $root.lookupEnum('squareup.memberships.model.ProgressMetric').values;
